/* eslint-disable */

import HomeFeed from "components/features/home-feed/HomeFeed";

const HomeFeedPage = () => {
  return <HomeFeed />;
};

export default HomeFeedPage;
